import { createContext, useContext, useEffect, useState } from "react";

const ContainerQueryContext = createContext({
	width: 0,
	windowWidth: 0,
});

export const useContainerQueryContext = () => useContext(ContainerQueryContext);
const CONTAINER_ID = "content";

export const ContainerQueryProvider = ({ children }) => {
	const [width, setWidth] = useState(0);
	const [windowWidth, setWindowWidth] = useState(window.innerWidth);

	useEffect(() => {
		const currentRef = document.getElementById(CONTAINER_ID);

		if (!currentRef || !setWidth) {
			return;
		}

		const observer = new ResizeObserver((entries) => {
			const { width } = entries[0].contentRect;
			setWidth(width);
		});

		observer.observe(currentRef);

		return () => {
			observer.unobserve(currentRef);
		};
	}, []);

	useEffect(() => {
		const handleResize = () => {
			setWindowWidth(window.innerWidth);
		};

		window.addEventListener("resize", handleResize);

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	return (
		<ContainerQueryContext.Provider value={{ width, windowWidth }}>
			{children}
		</ContainerQueryContext.Provider>
	);
};
